export const PublicationsTab = () => (
  <div className="flex-grow px-4 py-5 sm:p-6 overflow-y-scroll">
    <h1 className="text-gray-700 text-2xl font-bold p-2">Publications</h1>
    <div className="pb-2">
      <a
        href="https://dl.acm.org/doi/full/10.1145/3613904.3642755"
        target="_blank"
      >
        <h1 className="text-gray-700 text-xl font-bold p-2 pb-0">
          JupyterLab in Retrograde: Contextual Notifications That Highlight
          Fairness and Bias Issues for Data Scientists{" "}
        </h1>
      </a>
      <h2 className="text-indigo-600 font-semibold text-lg px-2 py-0">
        CHI '24 Best Paper Award
      </h2>
      <h2 className="text-gray-500 text-lg px-2 pt-0">
        Galen Harrison, Kevin Bryson, Ahmad Emmanuel Balla Bamba, Luca Dovichi,
        Aleksander Herrmann Binion, Arthur Borem, Blase Ur
      </h2>
    </div>
    <div className="pb-2">
      <a
        href="https://www.usenix.org/system/files/sec24fall-prepub-1238-borem.pdf"
        target="_blank"
      >
        <h1 className="text-gray-700 text-xl font-bold p-2 pb-0">
          Data Subjects’ Reactions to Exercising Their Right of Access
        </h1>
      </a>
      <h2 className="text-gray-500 text-lg px-2 pt-0">
        Arthur Borem, Elleen Pan, Olufunmilola Obielodan, Aurelie Roubinowitz,
        Luca Dovichi, Michelle L Mazurek, Blase Ur
      </h2>
    </div>
  </div>
);
